"use strict";
export class CoreAccessRule {
}
